import { useEffect, useMemo } from "react";
import { useEdgeCrossing } from "./EdgeCrossingContext";
import { buildBridgePath, pathToSegments } from "./edgeCrossingUtils";
/**
 * Hook that integrates an edge with the crossing bridge system.
 *
 * - Parses the SVG path into segments and registers them with the EdgeCrossingContext
 * - Detects crossings with all other registered edges
 * - Returns a modified SVG path with bridge arcs at crossing points
 */ export function useBridgeEdge(edgeId, svgPath, options) {
    const radius = options?.bridgeRadius ?? 6;
    const { registerEdgePath, unregisterEdgePath, getIntersections, version } = useEdgeCrossing();
    const segments = useMemo(()=>pathToSegments(svgPath), [
        svgPath
    ]);
    useEffect(function registerEdgePathForCrossing() {
        registerEdgePath(edgeId, segments);
        return ()=>unregisterEdgePath(edgeId);
    }, [
        edgeId,
        segments,
        registerEdgePath,
        unregisterEdgePath
    ]);
    const bridgePath = useMemo(()=>{
        void version;
        const crossings = getIntersections(edgeId, segments).filter((c)=>edgeId < c.otherEdgeId);
        const modified = buildBridgePath(svgPath, segments, crossings, radius);
        return modified ?? svgPath;
    }, [
        svgPath,
        edgeId,
        radius,
        version,
        getIntersections,
        segments
    ]);
    return {
        bridgePath,
        segments
    };
}

//# sourceMappingURL=useBridgeEdge.js.map